import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuex from "vuex";
import store from "./store";
import i18n from "./i18n"
import PortalVue from "portal-vue";
import VueMoment from 'vue-moment';
import Vuelidate from 'vuelidate';
import vueAwesomeCountdown from 'vue-awesome-countdown';
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VClamp from 'vue-clamp'
import vSelect from 'vue-select'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'vue-select/dist/vue-select.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import LayoutDefault from "./layouts/default.vue";
import LayoutAuth from "./layouts/auth.vue";
import LayoutBlank from "./layouts/blank.vue";
import pusher from './pusher';

import * as firebase1 from 'firebase/app';
import 'firebase/messaging';

let firebase = firebase1.default;

// // Initialize Firebase
console.log(firebase.messaging.isSupported());
if(firebase.messaging.isSupported())
{
  firebase.initializeApp({
    apiKey: "AIzaSyAd6REGe3lp5as5AJbJY8n-GnNFNY4gO_Q",
    authDomain: "english-advance.firebaseapp.com",
    projectId: "english-advance",
    storageBucket: "english-advance.appspot.com",
    messagingSenderId: "170965126135",
    appId: "1:170965126135:web:005639128551f330fafcf2",
    measurementId: "G-XF6T1TDHP1"    

  });

  Vue.prototype.$messaging = firebase.messaging();
  //navigator.serviceWorker.register('firebase-messaging-sw.js', {scope: "firebase-cloud-messaging-push-scope"})
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
      const messaging = firebase.messaging();
      messaging.useServiceWorker(registration);

  }).catch(err => {
      console.log(err)
  });
}

//import 'vue-instant/dist/vue-instant.css'
//import VueInstant from 'vue-instant'
import Autocomplete from 'v-autocomplete'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-autocomplete/dist/v-autocomplete.css'

Vue.use(Autocomplete)

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuex);
Vue.use(PortalVue);
//Vue.use(VueMoment);

//const moment = require('moment')
const moment = require('moment-timezone'); 
require('moment/locale/es')

Vue.use(VueMoment, {
  moment
})

Vue.use(Vuelidate);
//Vue.use(VueInstant)
Vue.use(vueAwesomeCountdown, 'vac')
Vue.component("v-clamp",VClamp);
Vue.component("default-layout", LayoutDefault);
Vue.component("auth-layout", LayoutAuth);
Vue.component("blank-layout", LayoutBlank);
Vue.component('v-select', vSelect)
Vue.component("icon", require('./components/iconBase').default);
Vue.config.productionTip = false;

//Pusher
Vue.prototype.$pusher = pusher;

Vue.mixin({
  data: function() {
      return {
          get apiURL() {
              return `${process.env.VUE_APP_API_URL}`;
          }
      };
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
